import { Component, Renderer } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Toast } from 'ionic-angular';
import { ExtraProvider } from '../../providers/extra/extra';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';


@IonicPage()
@Component({
  selector: 'page-panic',
  templateUrl: 'panic.html',
})
export class PanicPage {

  message: string = "";
  loading = false;
  contacts: any[];
  selRegistrationLogin : any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private viewCtrl: ViewController, 
    private extraProvider: ExtraProvider,
    private toastProvider: ToastProvider,
    private renderer: Renderer) {
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
       // this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
else{
      extraProvider.getPanicContacts().then(val => {
        if(val.status == "success"){
          this.contacts = val.data.phone_nos;
        }
      });
    }
      this.renderer.setElementClass(viewCtrl.pageRef().nativeElement, 'popup', true);
  }

  onPanic(type: string){
    this.loading=true;
    if(this.selRegistrationLogin){
       this.toastProvider.presentToast("You are Unauthorized to use this feature , Please request to admin.");
     }
else{
  this.extraProvider.sendPanicMessage(type, this.message).then(val => {
    if(val.status == "success"){
      this.dismiss();
      this.loading=false
        this.toastProvider.presentToast(val.message);
      }else if(val.status == "error"){
        this.toastProvider.presentToast(val.message);
      }
    });
  }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/panic/panic.ts